import { CheckBadgeIcon, ChevronLeftIcon } from '@heroicons/react/24/outline'
import { companyName } from 'config'
import jwtDecode from 'jwt-decode'
import { useState } from 'react'
import { sendParticipantForgetPasswordEmail } from 'services'
import { Button, Input2 } from 'stories/components'
import { useTitle } from 'utils/pageTitle'

export function ParticipantForgetPwd({ token, onSubmit: _onSubmit }: { token: string; onSubmit: Function }) {
  useTitle(`Forgot Password - ${companyName}`)

  const [isLoading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const onSubmit = async () => {
    let newError = ''
    if (!email) newError = 'Required'
    else if (token != 'signin') {
      const payload: any = jwtDecode(token)
      if (payload.email != email) newError = 'Email is wrong. Please confirm again.'
    }
    setError(newError)
    if (newError) return

    setLoading(true)
    sendParticipantForgetPasswordEmail({ email, token })
      .then(({ success }) => success && setSent(true))
      .finally(() => setLoading(false))
  }

  return (
    <div className="home-container sm:text-center lg:text-left w-full block mt-0 relative bg-stone-100 md:py-20">
      <div className="max-w-screen-2xl m-auto lg:pt-10 md:pt-5 sm:pt-2 pb-10 px-2 pt-4">
        <div className="bg-white rounded lg:max-w-xl max-w-full pl-6 pr-6 pt-8 pb-6 relative mx-auto">
          <p className="text-stone-800 text-3xl font-bold mb-3">Forgot Password</p>
          <div className="h-1 bg-shade-blue w-16 mb-5" />

          {sent ? (
            <>
              <div className="bg-blue-50 border border-blue-400 text-blue-700 px-4 py-3 rounded relative mb-4 text-[15.5px]">
                <div className="flex justify-center mb-3">
                  <CheckBadgeIcon className="w-10 h-10" />
                </div>
                <div className="max-w-xl">
                  If an account exists for that address, a new password is on its way to it.
                </div>
              </div>
              <Button className="mt-1" color="sky" full bold onClick={() => _onSubmit()}>
                Back to Sign In
              </Button>
            </>
          ) : (
            <>
              <Input2
                type="email"
                title="Email"
                value={email}
                required
                error={error}
                onChange={(value) => setEmail(value)}
                onKeyPress={(e: any) => e.charCode === 13 && onSubmit()}
              />
              <div className="my-7" />
              <Button className="mt-1" color="sky" full bold onClick={onSubmit} loading={isLoading}>
                Send me a new password
              </Button>
              <p
                className="flex items-center gap-1 mt-3 hover:text-gray-900 hover:underline text-gray-500 cursor-pointer"
                onClick={() => _onSubmit()}
              >
                <ChevronLeftIcon className="w-4 h-4" /> Back to Sign In
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
